import { Box, Button, CircularProgress, Tooltip } from '@mui/material';
import { FC, ReactNode } from 'react';

import { sxFooterActions, sxHeaderActions, sxMobileFooter } from '../styles';

type ValidationActionButtonsProps = {
  mobile: boolean;
  isGalleryOpen: boolean;
  cameraOpen: boolean;
  hasCapturedImage: boolean;
  isPreviewValidated: boolean;
  uploadingImage: boolean;
  onValidateWithImage: VoidFunction;
  onContinueGallery: VoidFunction;
  onCancelCamera: VoidFunction;
  onRetakePhoto: VoidFunction;
  onUsePhoto: VoidFunction;
};

export const ValidationActionButtons: FC<ValidationActionButtonsProps> = ({
  mobile,
  isGalleryOpen,
  cameraOpen,
  hasCapturedImage,
  isPreviewValidated,
  uploadingImage,
  onValidateWithImage,
  onContinueGallery,
  onCancelCamera,
  onRetakePhoto,
  onUsePhoto,
}) => {
  const size = mobile ? 'large' : 'medium';
  const groupSx = mobile ? sxFooterActions : sxHeaderActions;
  const buttonSx = mobile ? { flex: 1 } : undefined;

  let content: ReactNode = null;

  if (isGalleryOpen && !cameraOpen) {
    content = (
      <Box sx={groupSx}>
        <Tooltip title={isPreviewValidated ? 'Item is already validated' : ''} arrow>
          <Box component="span" sx={buttonSx}>
            <Button
              variant="outlined"
              color="inherit"
              size={size}
              fullWidth={mobile}
              disabled={isPreviewValidated}
              onClick={onValidateWithImage}
            >
              Validate with Image
            </Button>
          </Box>
        </Tooltip>
        <Button
          variant="contained"
          color="primary"
          size={size}
          fullWidth={mobile}
          sx={buttonSx}
          onClick={onContinueGallery}
        >
          Continue
        </Button>
      </Box>
    );
  } else if (cameraOpen && !hasCapturedImage) {
    content = (
      <Button variant="outlined" color="inherit" size={size} fullWidth={mobile} onClick={onCancelCamera}>
        Cancel
      </Button>
    );
  } else if (cameraOpen && hasCapturedImage) {
    content = (
      <Box sx={groupSx}>
        <Button
          variant="outlined"
          color="inherit"
          size={size}
          fullWidth={mobile}
          sx={buttonSx}
          disabled={uploadingImage}
          onClick={onRetakePhoto}
        >
          Retake
        </Button>
        <Button
          variant="contained"
          color="primary"
          size={size}
          fullWidth={mobile}
          sx={buttonSx}
          disabled={uploadingImage}
          startIcon={uploadingImage ? <CircularProgress aria-label="Loading..." size={16} color="inherit" /> : null}
          onClick={onUsePhoto}
        >
          Confirm
        </Button>
      </Box>
    );
  }

  if (!content) return null;

  return mobile ? <Box sx={sxMobileFooter}>{content}</Box> : content;
};
